import {  FormValidationRuleWithState } from "../types";
import { validateMultiInput, validateSingleInput } from "./same-value";
import { evaluates_as_hiddenV2 } from "../conditional-logic";

const duplicateValue: FormValidationRuleWithState = (c, v, s) => {
    if ((c.field_no_in_form_duplicates || c.field_not_same_as_email_field_sources) && v) {
        const inputType = c.type;
        for (const targetControl of s.controls as React.ReactElement[]) {
            if (targetControl.props.id !== c.id &&
                targetControl.props.type === inputType &&
                targetControl.props.name in s.values) {
                const targetValue = s.values[targetControl.props.name];
                const page = (s.controls as React.ReactElement[]).find(control =>
                    control.props.type === "page" && control.props.pageNumber === targetControl.props.pageNumber);
                const isPageHidden = !!page && evaluates_as_hiddenV2(page.props.conditionalLogic, s);
                const isControlHidden = evaluates_as_hiddenV2(targetControl.props.conditionalLogic, s);
                const [valid, message] = c.inputs
                    ? validateMultiInput(c, v, targetValue)
                    : validateSingleInput(c, v, targetValue);
                if (c.field_no_in_form_duplicates && !valid && !isPageHidden && !isControlHidden) {
                    return [valid, message];
                }
                // CPI-5878 - Validation to check the duplication of the selected email fields
                if (c.field_not_same_as_email_field_sources) {
                    const notSameEmailFieldSources = c.field_not_same_as_email_field_sources;
                    const targetControlId = targetControl.props.fieldId;
                    const checkSame = notSameEmailFieldSources.includes(targetControlId.toString());
                    if (checkSame && !valid) {
                        return [valid, message];
                    }
                }
            }
        }
    }
    return [true, ""];
};

export default duplicateValue;